import { defineMessages } from 'react-intl';
import { ImportErrorCodes } from '../../../data/types/import-error-codes';

export const messages = defineMessages({
  [ImportErrorCodes.INIT_CSV_GENERIC_ERROR]: {
    id: '7ze5oc',
    defaultMessage: 'File has an unknown error. Please try uploading your file again.',
    description: 'CSV import init generic failure message',
  },
  [ImportErrorCodes.INIT_CSV_WITHOUT_DATA_ROWS]: {
    id: 'WCeWyP',
    defaultMessage: 'No rows detected in uploaded CSV file.',
    description: 'CSV import init no rows failure message',
  },
  [ImportErrorCodes.INIT_CSV_DATA_ROWS_LIMIT_EXCEEDED]: {
    id: 'CNhPFt',
    defaultMessage: 'Limit of rows in uploaded CSV file exceeded. Limit is 2500 rows.',
    description: 'CSV import init too many rows failure message',
  },
  [ImportErrorCodes.INIT_UNABLE_TO_PARSE_CSV]: {
    id: '2Fq6y8',
    defaultMessage: 'Parsing CSV file error. Please try uploading corrected file.',
    description: 'CSV import init parsing error',
  },
  [ImportErrorCodes.INIT_UNABLE_TO_STORE_CSV]: {
    id: '7ze5oc',
    defaultMessage: 'File has an unknown error. Please try uploading your file again.',
    description: 'CSV import init generic failure message',
  },
});
